import React from "react";
import { Chip } from "../core/Chip";

export function SuggestionChips({ items = [], onPick, label }) {
  return (
    <div>
      {label && (
        <p style={{
          fontFamily: "var(--font-display)", fontSize: "var(--text-xs)",
          textTransform: "uppercase", letterSpacing: "var(--tracking-widest)",
          color: "var(--dany-meta)", marginBottom: "var(--space-3)",
        }}>{label}</p>
      )}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "var(--space-2)" }}>
        {items.map((it) => (
          <Chip key={it.label} icon={it.icon} onClick={() => onPick?.(it)}>{it.label}</Chip>
        ))}
      </div>
    </div>
  );
}
